import { useNavigate } from 'react-router-dom';
import Footer from '../../components/shared/Footer';

export default function DocsHome() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="max-w-4xl w-full bg-white rounded-lg shadow-lg p-10">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold mb-4 text-blue-700">
              Dentulu Developer Ecosystem
            </h1>
            <p className="text-gray-700 text-lg">
              Build powerful healthcare integrations with the most developer-friendly API platform in dental tech
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 my-12">
            <div className="text-center">
              <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">👨‍💻</span>
              </div>
              <h2 className="text-xl font-semibold mb-3">For Developers</h2>
              <p className="text-gray-600 mb-4">
                Build and integrate your applications with Dentulu's comprehensive API ecosystem
              </p>
              <button
                onClick={() => navigate('/login')}
                className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
              >
                Developer Login
              </button>
            </div>

            <div className="text-center">
              <div className="bg-red-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🛡️</span>
              </div>
              <h2 className="text-xl font-semibold mb-3">For Admins</h2>
              <p className="text-gray-600 mb-4">
                Manage developers, approve applications, and monitor the ecosystem
              </p>
              <button
                onClick={() => navigate('/admin-login')}
                className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition"
              >
                Admin Login
              </button>
            </div>
          </div>

          <div className="border-t pt-8 mt-8">
            <h3 className="text-lg font-semibold mb-4">Platform Features</h3>
            <div className="grid md:grid-cols-2 gap-4 text-sm">
              <div className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>RESTful API with comprehensive documentation</span>
              </div>
              <div className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Webhook event subscriptions for real-time updates</span>
              </div>
              <div className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Staging and production API key management</span>
              </div>
              <div className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Comprehensive testing and simulation tools</span>
              </div>
              <div className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>OAuth 2.0 authentication support</span>
              </div>
              <div className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Marketplace for showcasing your applications</span>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <p className="text-gray-600 mb-4">
              New to the platform?
            </p>
            <button
              onClick={() => navigate('/signup')}
              className="bg-green-600 text-white px-8 py-3 rounded hover:bg-green-700 transition"
            >
              Sign Up as Developer
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}